import { faCalendar, faLock, faPhone, faUser, faVenusMars } from "@fortawesome/free-solid-svg-icons";
import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import Webcam from "react-webcam";
import image from "../../images/image.svg";
import { checkUserExist, sendOTP, verifyOTP } from "../../store/thunks/register";
import { showToast } from "../../store/thunks/toasts";
import {
	DOB_YEAR,
	GENDER,
	MAX_DOB_IN_YEARS,
	MEDICAL_CONDITIONS,
	RESEND_OTP_TIMEOUT_IN_SECONDS,
	STATE_DANGER,
	STATE_DEFAULT,
	TOAST_STATE_DANGER,
} from "../../utils/constants";
import Button from "../DesignSystem/Button/Button";
import Checkbox from "../DesignSystem/Checkbox/Checkbox";
import CustomInput from "../DesignSystem/CustomInput/CustomInput";
import Dropdown from "../DesignSystem/Dropdown/Dropdown";
import avatar from "../../images/avatar.svg";

let resendOTPTimer = null;
const width = 300;
const height = 300;

export default connect((state) => ({ ...state.register }), {
	sendOTP,
	verifyOTP,
	showToast,
	checkUserExist,
})(({ isCheckingUser, onNextButtonClick, setGenericErrorMessage, genericErrorMessage, sendingOTP, verifyingOTP }) => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();
	const webcamRef = useRef(null);

	const [webcamImage, setWebcamImage] = useState(null);
	const [isPhotoCaptured, setIsPhotoCaptured] = useState(false);
	const [isTakingPicture, setIsTakingPicture] = useState(false);

	const [firstName, setFirstName] = useState("");
	const [firstNameInputState, setFirstNameInputState] = useState("");
	const [firstNameError, setFirstNameError] = useState("");

	const [lastName, setLastName] = useState("");
	const [lastNameInputState, setLastNameInputState] = useState("");
	const [lastNameError, setLastNameError] = useState("");

	const [fatherName, setFatherName] = useState("");
	const [fatherNameInputState, setFatherNameInputState] = useState("");
	const [fatherNameError, setFatherNameError] = useState("");

	const [dob, setDob] = useState("");
	const [dobError, setDobError] = useState("");
	const [dobInputState, setDobInputState] = useState("");

	const [phoneNumber, setPhoneNumber] = useState("");
	const [phoneNumberError, setPhoneNumberError] = useState("");
	const [phoneNumberInputState, setPhoneNumberInputState] = useState("");

	const [otp, setOtp] = useState("");
	const [otpError, setOtpError] = useState("");
	const [otpInputState, setOtpInputState] = useState("");

	const [photoError, setPhotoError] = useState("");

	const [genderOptions, setGenderOptions] = useState("");
	const [gender, setGender] = useState("");
	const [genderError, setGenderError] = useState("");
	const [genderInputState, setGenderInputState] = useState("");

	const [medicalCondition, setMedicalCondition] = useState("");
	const [medicalConditionInputState, setMedicalConditionInputState] = useState("");
	const [medicalConditionError, setMedicalConditionError] = useState("");

	const [sendOtpButtonDisabledState, setSendOtpButtonDisabledState] = useState(true);
	const [verifyOTPButtonDisabledState, setVerifyOTPButtonDisabledState] = useState(true);
	const [hasMedicalCondition, setHasMedicalCondition] = useState(false);
	const [buttonDisabled, setButtonDisabled] = useState(true);
	const [resendOTPMessage, setResendOTPMessage] = useState(null);

	const [formStateMapping, setFromStateMapping] = useState({
		firstName: {
			isSet: false,
			setErrorFunc: setFirstNameError,
			setState: setFirstNameInputState,
		},
		lastName: {
			isSet: false,
			setErrorFunc: setLastNameError,
			setState: setLastNameInputState,
		},
		fatherName: {
			isSet: false,
			setErrorFunc: setFatherNameError,
			setState: setFatherNameInputState,
		},
		gender: {
			isSet: false,
			setErrorFunc: setGenderError,
			setState: setGenderInputState,
		},
		dob: {
			isSet: false,
			setErrorFunc: setDobError,
			setState: setDobInputState,
		},
		phoneNumber: {
			isSet: false,
			setErrorFunc: setPhoneNumberError,
			setState: setPhoneNumberInputState,
		},
		otp: {
			isSet: false,
			setErrorFunc: setOtpError,
			setState: setOtpInputState,
		},
		isOTPRequested: {
			isSet: false,
		},
		isOTPVerified: {
			isSet: false,
			showBanner: true,
			bannerText: formatMessage({ id: "public.register.verifyOTPError" }),
		},
		photo: {
			isSet: false,
			setErrorFunc: setPhotoError,
		},
		medicalConditions: {
			isSet: true,
			setErrorFunc: setMedicalConditionError,
			setState: setMedicalConditionInputState,
		},
	});

	const firstNameInput = useRef();
	const lastNameInput = useRef();
	const fatherNameInput = useRef();
	const dobInput = useRef();
	const phoneNumberInput = useRef();
	const otpInput = useRef();
	const genderInput = useRef();
	const medicalConditionInput = useRef();

	useEffect(() => {
		let genderOptions = [];

		GENDER.forEach((gen) => {
			genderOptions.push(formatMessage({ id: `public.${gen.label}` }));
		});

		setGenderOptions(genderOptions);
	}, [formatMessage]);

	useEffect(() => {
		const trigger = document.getElementById("trigger");
		trigger.addEventListener("click", () => {
			openCamera();
		});
		//trigger.click();
	}, []);

	const validateField = (inputValue, onError, errorMessage, stateKey) => {
		let isError = false;

		if (!inputValue.length) {
			onError(formatMessage({ id: errorMessage }));
			isError = true;
		}

		if (isError) {
			setButtonDisabled(true);
			formStateMapping[stateKey].isSet = false;
		} else {
			setButtonDisabled(false);
			formStateMapping[stateKey].isSet = true;
		}

		return isError;
	};

	const handleFirstNameChange = () => {
		setFirstNameError("");
		const state = validateField(
			firstNameInput.current.value,
			setFirstNameError,
			"public.firstname.error",
			"firstName"
		);
		setFirstNameInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setFirstName(firstNameInput.current.value);

		return state;
	};

	const handleLastNameChange = () => {
		setLastNameError("");
		const state = validateField(lastNameInput.current.value, setLastNameError, "public.lastname.error", "lastName");
		setLastNameInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setLastName(lastNameInput.current.value);

		return state;
	};

	const handleFatherNameChange = () => {
		setFatherNameError("");
		const state = validateField(
			fatherNameInput.current.value,
			setFatherNameError,
			"public.fathername.error",
			"fatherName"
		);
		setFatherNameInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setFatherName(fatherNameInput.current.value);

		return state;
	};

	const validateDob = (inputValue, onError, errorMessage, stateKey) => {
		let isError = false;
		const today = moment("2025/05/17", "YYYY/MM/DD");
		const age = today.diff(moment(inputValue).format("YYYY/MM/DD"), "years");

		if (!inputValue.length) {
			onError(formatMessage({ id: errorMessage }));
			isError = true;
		} else if (age < DOB_YEAR || age >= MAX_DOB_IN_YEARS) {
			onError(formatMessage({ id: "public.dob.ageLimitError" }, { min: DOB_YEAR, max: MAX_DOB_IN_YEARS }));
			isError = true;
		}

		if (isError) {
			setButtonDisabled(true);
			formStateMapping[stateKey].isSet = false;
		} else {
			setButtonDisabled(false);
			formStateMapping[stateKey].isSet = true;
		}

		return isError;
	};

	const handleDobChange = () => {
		setDobError("");
		const state = validateDob(dobInput.current.value, setDobError, "public.dob.error", "dob");
		setDobInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setDob(parseInt((new Date(dobInput.current.value).getTime() / 1000).toFixed(0)));

		return state;
	};

	const validatePhoneNumber = (inputValue, onError, errorMessage, stateKey) => {
		let isError = false;

		if (!inputValue) {
			onError(formatMessage({ id: errorMessage }));
			isError = true;
		} else if (inputValue.length !== 10) {
			onError(formatMessage({ id: "public.phonenumber.invalid" }));
			isError = true;
		}

		if (isError) {
			setButtonDisabled(true);
			formStateMapping[stateKey].isSet = false;
		} else {
			setButtonDisabled(false);
			formStateMapping[stateKey].isSet = true;
		}

		return isError;
	};

	const handlePhoneNumberChange = () => {
		setPhoneNumberError("");
		const state = validatePhoneNumber(
			phoneNumberInput.current.value,
			setPhoneNumberError,
			"public.phonenumber.error",
			"phoneNumber"
		);
		setPhoneNumberInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setPhoneNumber(phoneNumberInput.current.value);

		if (!state) {
			setSendOtpButtonDisabledState(false);
		} else {
			setSendOtpButtonDisabledState(true);
		}

		return state;
	};

	const startResendOTPTimer = () => {
		let countdown = RESEND_OTP_TIMEOUT_IN_SECONDS;
		resendOTPTimer = setInterval(() => {
			countdown -= 1;
			setResendOTPMessage(formatMessage({ id: "public.otp.resendMessage" }, { time: countdown }));
			if (countdown <= 0) {
				clearInterval(resendOTPTimer);
				setSendOtpButtonDisabledState(false);
				setResendOTPMessage(null);
			}
		}, [1000]);
	};

	const onClickSendOTP = async () => {
		const state = handlePhoneNumberChange();
		if (state) {
			return;
		}

		const sendOTPResponse = await dispatch(sendOTP({ mobileNumber: phoneNumber }));
		if (sendOTPResponse) {
			formStateMapping["isOTPRequested"].isSet = true;
			startResendOTPTimer();
			setSendOtpButtonDisabledState(true);
			dispatch(
				showToast({
					message: "public.phonenumber.OTPsent",
				})
			);
		} else {
			setSendOtpButtonDisabledState(false);
			formStateMapping["isOTPRequested"].isSet = false;
			setPhoneNumberError(formatMessage({ id: "public.phonenumber.APIerror" }));
		}
	};

	const handleOtpChange = () => {
		setOtpError("");
		const state = validateField(otpInput.current.value, setOtpError, "public.otp.error", "otp");
		setOtpInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setOtp(otpInput.current.value);

		if (!state) {
			setVerifyOTPButtonDisabledState(false);
		} else {
			setVerifyOTPButtonDisabledState(true);
		}

		return state;
	};

	const onClickVerifyOTP = async () => {
		const state = handleOtpChange();
		if (state) {
			return;
		}

		const verifyOTPResponse = await dispatch(verifyOTP({ mobileNumber: phoneNumber, otp: otp }));
		if (verifyOTPResponse) {
			formStateMapping["isOTPVerified"].isSet = true;
			setVerifyOTPButtonDisabledState(true);

			if (resendOTPTimer) {
				clearInterval(resendOTPTimer);
				setResendOTPMessage("");
			}

			dispatch(
				showToast({
					message: "public.OTP.verifiedSuccessfully",
				})
			);
		} else {
			setVerifyOTPButtonDisabledState(false);
			formStateMapping["isOTPVerified"].isSet = false;
			setOtpError(formatMessage({ id: "public.OTP.invalid" }));
		}
	};

	const openCamera = () => {
		setIsTakingPicture(true);
	};

	const retakePhoto = () => {
		setIsPhotoCaptured(false);
		setIsTakingPicture(true);
	};

	const checkIfDeviceIsSamsung = () => {
		if (navigator.userAgent.match(/SAMSUNG|SGH-[I|N|T]|GT-[I|P|N]|SM-[N|P|T|Z|G]|SHV-E|SCH-[I|J|R|S]|SPH-L/i)) {
			return true;
		}

		return false;
	};

	const capturePhoto = () => {
		const imageSrc = webcamRef.current.getScreenshot();
		setWebcamImage(imageSrc);
		setIsPhotoCaptured(true);
		formStateMapping["photo"].isSet = imageSrc ? true : false;
	};

	const handleGenderInputChange = () => {
		setGenderError("");
		const state = validateField(genderInput.current.value, setGenderError, "public.gender.error", "gender");
		setGenderInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setGender(genderInput.current.value);

		return state;
	};

	const handleMedicalConditionChange = (e) => {
		setHasMedicalCondition(e.target.checked);

		if (e.target.checked && !medicalCondition) {
			formStateMapping.medicalConditions.isSet = false;
		} else {
			formStateMapping.medicalConditions.isSet = true;
		}
	};

	const handleMedicalConditionInputChange = () => {
		setMedicalConditionError("");
		const state = validateField(
			medicalConditionInput.current.value,
			setMedicalConditionError,
			"public.medicalCondition.error",
			"medicalConditions"
		);
		setMedicalConditionInputState(state ? STATE_DANGER : STATE_DEFAULT);
		setMedicalCondition(medicalConditionInput.current.value);

		return state;
	};

	const goToNextStep = async () => {
		let unsetData = {};

		for (let key in formStateMapping) {
			if (!formStateMapping[key].isSet) {
				let item = {};
				item[key] = formStateMapping[key];
				unsetData = {
					...unsetData,
					...item,
				};
			}
		}

		if (Object.keys(unsetData).length) {
			for (let key in unsetData) {
				if (!unsetData[key].isSet && unsetData[key].setErrorFunc) {
					unsetData[key].setErrorFunc(formatMessage({ id: "public.register.mandatoryFieldError" }));

					if (unsetData[key].setState) {
						unsetData[key].setState(STATE_DANGER);
					}
				}

				if (!unsetData[key].isSet && unsetData[key].showBanner) {
					setGenericErrorMessage(unsetData[key].bannerText);
				}
			}

			return;
		}

		const payload = {
			firstName: firstName,
			lastName: lastName,
			fathersName: fatherName,
			mobileNumber: phoneNumber,
		};
		const doesUserExist = await dispatch(checkUserExist(payload));
		if (!doesUserExist) {
			setGenericErrorMessage("");
			onNextButtonClick({
				firstName: firstName,
				lastName: lastName,
				fathersName: fatherName,
				dob: dob,
				mobileNumber: phoneNumber,
				photo: webcamImage,
				gender,
				medicalConditions: hasMedicalCondition ? medicalCondition : MEDICAL_CONDITIONS.NONE,
			});
		} else {
			setGenericErrorMessage(formatMessage({ id: "public.register.userDuplicateError" }));
		}
	};

	return (
		<>
			<div id="trigger" style={{ display: "none" }}>
				<Webcam
					ref={webcamRef}
					forceScreenshotSourceSize
					audio={false}
					screenshotFormat="image/jpeg"
					style={{ width: 400, height: 400 }}
				/>
			</div>
			<div className="row mt-16">
				<div className="col-lg-6">
					<CustomInput
						id="firstname"
						label="public.firstname"
						icon={faUser}
						isMandatory={true}
						placeholder="public.firstname.placeholder"
						ref={firstNameInput}
						state={firstNameInputState}
						onChange={handleFirstNameChange}
					/>
					{firstNameError && <div className="text text-body--5 text-left text-danger">{firstNameError}</div>}
				</div>
				<div className="col-lg-6">
					<CustomInput
						id="lastname"
						label="public.lastname"
						icon={faUser}
						isMandatory={true}
						placeholder="public.lastname.placeholder"
						ref={lastNameInput}
						state={lastNameInputState}
						onChange={handleLastNameChange}
					/>
					{lastNameError && <div className="text text-body--5 text-left text-danger">{lastNameError}</div>}
				</div>
			</div>
			<div className="row mt-16">
				<div className="col-lg-6">
					<CustomInput
						id="fathername"
						label="public.fathername"
						icon={faUser}
						isMandatory={true}
						placeholder="public.fathername.placeholder"
						ref={fatherNameInput}
						state={fatherNameInputState}
						onChange={handleFatherNameChange}
					/>
					{fatherNameError && (
						<div className="text text-body--5 text-left text-danger">{fatherNameError}</div>
					)}
				</div>
				<div className="col-lg-6">
					<CustomInput
						id="dob"
						type="date"
						label="public.dob"
						icon={faCalendar}
						isMandatory={true}
						placeholder="public.dob.placeholder"
						ref={dobInput}
						state={dobInputState}
						onChange={handleDobChange}
						caption={"public.dob.caption"}
					/>
					{dobError && <div className="text text-body--5 text-left text-danger">{dobError}</div>}
				</div>
			</div>
			<div className="row mt-16">
				<div className="col-lg-8">
					<div className="flex direction-row align-items-end">
						<CustomInput
							id="phonenumber"
							label="public.phonenumber"
							icon={faPhone}
							isMandatory={true}
							placeholder="public.phonenumber.placeholder"
							ref={phoneNumberInput}
							state={phoneNumberInputState}
							max={10}
							onChange={handlePhoneNumberChange}
						/>
						<Button
							className="button-secondary button-md ml-16"
							label="public.action.sendOTP"
							disabled={sendOtpButtonDisabledState}
							loading={sendingOTP}
							onClick={onClickSendOTP}
						/>
					</div>

					{resendOTPMessage && (
						<div className="text text-body--5 text-left text-disabled">{resendOTPMessage}</div>
					)}
					{phoneNumberError && (
						<div className="text text-body--5 text-left text-danger">{phoneNumberError}</div>
					)}
				</div>
			</div>
			<div className="row mt-16">
				<div className="col-lg-8 flex direction-col align-items-start">
					<div className="flex direction-row align-items-end">
						<CustomInput
							id="otp"
							type="password"
							label="public.otp"
							icon={faLock}
							isMandatory={true}
							placeholder="public.otp.placeholder"
							ref={otpInput}
							state={otpInputState}
							max={4}
							onChange={handleOtpChange}
						/>
						<Button
							className="button-secondary button-md ml-16"
							label="public.action.verifyOTP"
							disabled={verifyOTPButtonDisabledState || dobError}
							loading={verifyingOTP}
							onClick={onClickVerifyOTP}
						/>
					</div>

					{otpError && <div className="text text-body--5 text-left text-danger">{otpError}</div>}
				</div>
			</div>
			<div className="row mt-16">
				<div className="col-lg-6 flex direction-col align-items-start">
					<label className="text text-body--4">
						{formatMessage({ id: `public.avatar.placeholder` })}
						<span className="input-mandatory-sign ml-8">*</span>
					</label>
					<div>
						{isPhotoCaptured ? (
							<div className="flex direction-row align-items-center">
								<img src={webcamImage} className="webcam-image" alt="webcam-captured-image" />
								<Button
									className="button-secondary button-md ml-16"
									label="public.action.retakePhoto"
									onClick={retakePhoto}
								/>
							</div>
						) : isTakingPicture ? (
							<>
								<div className="flex direction-row align-items-center">
									<div className="camera-wrapper">
										<img src={avatar} className="avatar" />
										<Webcam
											ref={webcamRef}
											forceScreenshotSourceSize
											audio={false}
											screenshotFormat="image/jpeg"
											height={height}
											width={width}
										/>
										<div className="text text-body--5">
											{formatMessage({ id: "public.register.cameraInfo" })}
										</div>
									</div>
									<Button
										className="button-secondary button-md ml-16"
										label="public.action.capturePhoto"
										onClick={capturePhoto}
									/>
								</div>
								{photoError && (
									<div className="text text-body--5 text-left text-danger">{photoError}</div>
								)}
							</>
						) : (
							<div className="flex direction-col">
								<div className="flex direction-row align-items-center">
									<img src={image} alt="default-avatar" />
									<Button
										className="button-secondary button-md ml-16"
										label="public.action.openCamera"
										onClick={openCamera}
									/>
								</div>

								{photoError && (
									<div className="text text-body--5 text-left text-danger">{photoError}</div>
								)}
							</div>
						)}
					</div>
				</div>
				<div className="col-lg-6">
					{genderOptions && (
						<Dropdown
							id="gender"
							label="public.gender"
							icon={faVenusMars}
							isMandatory={true}
							placeholder="public.gender.placeholder"
							ref={genderInput}
							state={genderInputState}
							options={genderOptions}
							onChange={handleGenderInputChange}
						/>
					)}
					{genderError && <div className="text text-body--5 text-left text-danger">{genderError}</div>}
				</div>
			</div>
			<div className="row flex direction-col align-items-start mt-16">
				<Checkbox label="public.medical.placeholder" onChange={handleMedicalConditionChange} />
				{hasMedicalCondition ? (
					<>
						<CustomInput
							id="medicalCondition"
							placeholder="public.medicalCondition.placeholder"
							ref={medicalConditionInput}
							state={medicalConditionInputState}
							onChange={handleMedicalConditionInputChange}
						/>
						{medicalConditionError && (
							<div className="text text-body--5 text-left text-danger">{medicalConditionError}</div>
						)}
					</>
				) : (
					<></>
				)}
			</div>
			<div className="row pb-16">
				<div className="col-lg-12 flex direction-col align-items-end">
					{genericErrorMessage && <div className="text text-body--4 text-danger">{genericErrorMessage}</div>}
					<Button
						className="button-primary mt-16"
						label="public.action.next"
						disabled={buttonDisabled}
						loading={isCheckingUser || sendingOTP || verifyingOTP}
						onClick={goToNextStep}
					/>
				</div>
			</div>
		</>
	);
});
